<template>
  <v-footer
    :app="fixed"
    class="footer justify-center align-bottom"
    color="navy darken-1"
    :class="{ 'pt-7': paddedTop, 'pb-7': paddedBottom }"
  >
    <div class="d-flex white--text">
      <div>
        &copy; 2024 - Dai laboratori di
        <a
          class="secondary--text text-decoration-none"
          :href="host_fantapazz"
          target="_blank"
          >fantapazz.com</a
        >
        con
      </div>
      <v-icon class="ml-1 error--text" x-small>favorite</v-icon>
    </div>
  </v-footer>
</template>

<script>
import Config from "../../config-app/config";

export default {
  name: "asta-footer",
  props: {
    fixed: {
      type: Boolean,
    },
    paddedTop: {
      type: Boolean,
    },
    paddedBottom: {
      type: Boolean,
    },
  },
  data() {
    return {
      host_fantapazz: Config.HOST_FANTAPAZZ,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../main.scss";
.footer {
  box-shadow: 0px -5px 22px 0px rgb(0 0 0 / 12%) !important;
}
</style>
